<template>
    <div>
        <el-dialog
            :title="importitle"
            width="90%"
            :visible.sync="dialogVisible"
            @close="hideDialog"
        >
            <el-form
                :inline="true"
                :rules="formRules"
                :model="importPar"
                size="mini"
                style="text-align:left"
            >
                <el-form-item label="备注" prop="importBatch">
                    <el-input
                        style="width:150px"
                        placeholder="请输入导入备注"
                        v-model="importPar.importBatch"
                    >
                    </el-input>
                </el-form-item>
                <el-form-item v-if="isZhaoLuRankImport">
                    <a
                        href="static/excel/专业级预估位次处理模板.xlsx"
                        class="download-btn el-button el-button--primary"
                    >
                        下载专业级模板
                    </a>
                    <a
                        href="static/excel/院校级预估位次处理模板.xlsx"
                        class="download-btn el-button el-button--primary"
                    >
                        下载院校级模板
                    </a>
                </el-form-item>
                <el-form-item v-else-if="isZhaoLuRankScoreImport">
                    <a
                        href="static/excel/位次转分数处理模板.xlsx"
                        class="download-btn el-button el-button--primary"
                    >
                        下载模板
                    </a>
                </el-form-item>
                <el-form-item v-else>
                    <el-button type="primary" @click="downloadTemplate"
                        >下载模板</el-button
                    >
                </el-form-item>

                <el-form-item>
                    <el-upload
                        style="width:220px"
                        :action="uploadUrl"
                        :on-preview="handlePreview"
                        :on-remove="handleRemove"
                        :headers="headers"
                        :before-remove="beforeRemove"
                        :limit="1"
                        :on-exceed="handleExceed"
                        :before-upload="beforeAvatarUpload"
                        :on-success="success"
                        :on-error="upLoadErr"
                        :with-credentials="true"
                    >
                        <el-button size="medium" type="primary">上传</el-button>
                        <div slot="tip" class="el-upload-tip">
                            先下载模板编辑后再上传
                        </div>
                    </el-upload>
                </el-form-item>
                <el-form-item>
                    <el-button
                        class="importBtn"
                        icon="el-icon-upload2"
                        type="warning"
                        @click="importExcel"
                    >
                        {{ importBtnName }}
                    </el-button>
                </el-form-item>
            </el-form>
            <div style="color: red; padding-bottom: 10px;text-align: left;">{{importExplain}}</div>
            <perm-table
                :page="page"
                :columns="columns"
                :selectionChange="selectionChange"
                :handleCurrentHandle="handleCurrentHandle"
                :loading="loading"
                size="mini"
                :showEdit="true"
                :editLabel="editLabel"
                :showOperation="true"
                :showMore="true"
                permsEdit="sys:log"
                @findPage="getRecodes"
                @handleShoMore="handleShoMore"
                @handleEdit="dlFile"
            >
            </perm-table>
        </el-dialog>

        <el-dialog
            title="请选择导入类型"
            :visible.sync="importTypeVisible"
            top="25vh"
            width="40%"
        >
            <el-row>
                <el-radio v-model="importExcelType" :label="1" border>
                    专业级
                </el-radio>
                <el-radio v-model="importExcelType" :label="2" border>
                    院校级
                </el-radio>
            </el-row>
            <div class="dialog-btn">
                <el-button type="primary" @click="handleImport">
                    确定
                </el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import PermTable from '@/components/Component/PermTable/Index'
import PermButton from '@/components//Component/PermButton/Index'
// import { baseUrl, uploadUrl } from '../../../utils/global'
// import * as ZlInfo from '../../../http/moudules/dataManage/zlinfo'

export default {
    components: {
        PermTable,
        PermButton
    },
    props: {
        importitle: {
            type: String,
            default: '导入'
        },
        importType: {
            type: Number,
            default: 1
        },
        importableId: {
            type: Number,
            default: 1
        },
        isProvince: {
            type: Boolean,
            default: false
        },
        isXkpage: {
            type: Boolean,
            default: false
        },
        isXkExam: {
            type: Boolean,
            default: false
        },
        isTouDang: {
            type: Boolean,
            default: false
        },
        isZhaoLu: {
            type: Boolean,
            default: false
        },
        isZhaoLuCheck: {
            type: Boolean,
            default: false
        },
        isZhaoLuRankImport: {
            type: Boolean,
            default: false
        },
        isZhaoLuRankScoreImport: {
            type: Boolean,
            default: false
        },
        isProfRemark: {
            type: Boolean,
            default: false
        },
        isProfInfo: {
            type: Boolean,
            default: false
        },
        isOnLineSchool: {
            type: Boolean,
            default: false
        },
        isTxExamType: {
            type: Boolean,
            default: false
        },
        isProfPredict: {
            type: Boolean,
            default: false
        },
        isSchoolPredict: {
            type: Boolean,
            default: false
        },
        isSegment: {
            type: Boolean,
            default: false
        },
        isProvinceBatch: {
            type: Boolean,
            default: false
        },
        isProvinceBatchLine: {
            type: Boolean,
            default: false
        },
        isProvinceScoreLine: {
            type: Boolean,
            default: false
        },
        isJointCate: {
            type: Boolean,
            default: false
        },
        isSchoolRank: {
            type: Boolean,
            default: false
        },
        isProvJoint: {
            type: Boolean,
            default: false
        },
        isProfLevel: {
            type: Boolean,
            default: false
        },
        isProfexam: {
            type: Boolean,
            default: false
        },
        isEnrollformula: {
            type: Boolean,
            default: false
        },
        isSmallscorelimit: {
            type: Boolean,
            default: false
        },
        isSameprof: {
            type: Boolean,
            default: false
        },
        isExamAreaAgent: {
            type: Boolean,
            default: false
        },
        isSchTxExamType: {
            type: Boolean,
            default: false
        },
        importBtnName: {
            type: String,
            default: '导入'
        },
        importExplain: {
            type: String,
            default: ''
        },
        isAdmissionSchoolType: {
            type: Boolean,
            default: false
        },
        isCollectionSchoolType: {
            type: Boolean,
            default: false
        },
        isProvinceScheduleType: {
            type: Boolean,
            default: false
        },
        isExamScheduleType: {
            type: Boolean,
            default: false
        },
        isAfterScheduleType: {
            type: Boolean,
            default: false
        },
        isMobile: {
            type: Boolean,
            default: false
        },
        isSysUserType: {
            type: Boolean,
            default: false
        },
        isExceptions: {
            type: Boolean,
            default: false
        }

    },
    data() {
        return {
            page: {},
            columns: [],
            editLabel: '下载',
            loading: true,
            dialogVisible: true,
            importTypeVisible: false,
            importExcelType: 1,
            importForm: {
                importBatch: ''
            },
            pageRe: {
                current: 1,
                size: 5
            },
            interVal: '',
            headers: {
                'access-token': sessionStorage.getItem('access-token')
            },
            formRules: {
                importBatch: [
                    {
                        required: true,
                        message: '导入批次不能为空',
                        trigger: 'blur'
                    }
                ]
            },
            uploadUrl: `${this.global.uploadUrl}/common/file/upload`,
            importPar: {
                tableId: this.importableId,
                importBatch: '',
                filePath: '',
                originName: ''
            },
            progressData: '100%'
        }
    },
    methods: {
        handleExceed() {},
        beforeRemove() {},
        handleRemove() {},
        handlePreview() {},
        beforeAvatarUpload(file) {
            var testmsg = file.name.substring(file.name.lastIndexOf('.') + 1)
            const extension = testmsg === 'xls'
            const extension2 = testmsg === 'xlsx'
            const extension3 = testmsg === 'zip'
            const isLt2M = file.size / 1024 / 1024 < 200
            if (!extension && !extension2 && !extension3) {
                this.$message({
                    message: '上传文件只能是 xls、xlsx、zip 格式!',
                    type: 'warning'
                })
            }
            if (!isLt2M) {
                this.$message({
                    message: '上传文件大小不能超过 200MB!',
                    type: 'warning'
                })
            }
            return extension || extension2 || (extension3 && isLt2M)
        },
        // 上传成功
        success(response, file, fileList) {
            var data = {
                filePath: response.data,
                originName: file.name
            }
            if (this.isZhaoLuRankImport) {
                // 根据文件名称设置默认级别
                if (file.name.includes('院校级')) {
                    this.importExcelType = 2
                } else {
                    this.importExcelType = 1
                }
            }
            Object.assign(this.importPar, data)
        },
        upLoadErr(err, file, fileList) {
            if (err) {
                this.$message({ message: '导入失败', type: 'error' })
                return
            }
        },
        importExcel() {
            if (!this.importPar.importBatch) {
                this.$message({ message: '请先输入批次', type: 'warning' })
                return
            }
            if (this.isZhaoLuRankImport) {
                // 预估预估位次先选择类型
                this.importTypeVisible = true
            } else {
                this.handleImport()
            }
            // if (this.interVal) {
            //     clearInterval(this.interVal)
            //     this.interVal = ''
            // }
        },
        // 导入
        handleImport() {
            if (this.importTypeVisible) {
                this.importTypeVisible = false
            }
            if (this.isProvince) {
                var module = 'Provincetj'
                var method = 'importProvinceData'
            } else if (this.isXkpage) {
                module = 'Xkinfo'
                method = 'importXKinfo'
            } else if (this.isXkExam) {
                module = 'Examplaceinfo'
                method = 'importEPInfo'
            } else if (this.isTouDang) {
                module = 'TDInfo'
                method = 'importTData'
            } else if (this.isZhaoLu) {
                module = 'ZlInfo'
                method = 'importZLData'
            } else if (this.isZhaoLuCheck) {
                if (this.importType == 127) {
                    module = 'ZlInfo'
                    method = 'checkZLDataSpecial'
                } else if (this.importType == 128) {
                    module = 'ZlInfo'
                    method = 'checkZLDataMajor'
                } else if (this.importType == 129) {
                    module = 'ZlInfo'
                    method = 'checkZLDataAliquot'
                } else {
                    module = 'ZlInfo'
                    method = 'checkZLData'
                }
            } else if (this.isZhaoLuRankImport) {
                module = 'ZlInfo'
                method = 'importZLRank'
            } else if (this.isZhaoLuRankScoreImport) {
                module = 'ZlInfo'
                method = 'importZLScoreRank'
            } else if (this.isProfRemark) {
                module = 'ProfRemark'
                method = 'importProfRemark'
            } else if (this.isProfInfo) {
                module = 'ProfInfo'
                method = 'importProfInfo'
            } else if (this.isOnLineSchool) {
                module = 'Onlinschool'
                method = 'importOnLineSchool'
            } else if (this.isTxExamType) {
                module = 'TxExamType'
                method = 'importTxExamType'
            } else if (this.isProfPredict) {
                module = 'ProfPredict'
                method = 'importProfPredict'
            } else if (this.isSchoolPredict) {
                module = 'SchoolPredict'
                method = 'importSchoolPredict'
            } else if (this.isSegment) {
                if (this.importType == 41) {
                    module = 'SegmentTable'
                    method = 'importSegment'
                } else if (this.importType == 152) {
                    module = 'SegmentTable'
                    method = 'importBuild'
                } else if (this.importType == 153) {
                    module = 'SegmentTable'
                    method = 'importMerge'
                } else {
                    module = 'SegmentTable'
                    method = 'importMergeSegment'
                }
            } else if (this.isProvinceBatch) {
                module = 'ProvinceBatch'
                method = 'importProvinceBatch'
            } else if (this.isProvinceBatchLine) {
                module = 'ProvinceBatchLine'
                method = 'importProvinceBatchLine'
            } else if (this.isProvinceScoreLine) {
                module = 'ProvinceScoreLine'
                method = 'importProvinceScore'
            } else if (this.isJointCate) {
                module = 'prof'
                method = 'importJointCate'
            } else if (this.isSchoolRank) {
                module = 'SchoolRank'
                method = 'importSchoolRank'
            } else if (this.isProvJoint) {
                module = 'prof'
                method = 'importProvJointCategory'
            } else if (this.isProfLevel) {
                module = 'ProfLevel'
                method = 'importProfLevel'
            } else if (this.isProfexam) {
                module = 'Profexamcategory'
                method = 'importProfexam'
            } else if (this.isEnrollformula) {
                module = 'Enrollformula'
                method = 'importEnrollformula'
            } else if (this.isSmallscorelimit) {
                module = 'Smallscorelimit'
                method = 'importSmallscorelimit'
            } else if (this.isSameprof) {
                module = 'Sameprof'
                method = 'importSameprof'
            } else if (this.isExamAreaAgent) {
                module = 'Exam'
                method = 'importExamAreaAgent'
            } else if (this.isSchTxExamType) {
                module = 'TxExamType'
                method = 'importSchTxExamType'
            } else if (this.isAdmissionSchoolType) {
                module = 'SchoolType'
                method = 'importSchoolType'
            } else if (this.isMobile) {
                module = 'crm'
                method = 'importMobile'
            } else if (this.isCollectionSchoolType) {
                module = 'collectionschool'
                method = 'importSchool'
            } else if (this.isProvinceScheduleType) {
                module = 'schedule'
                method = 'importSchedule'
            } else if (this.isExamScheduleType) {
                module = 'schedule'
                method = 'importExamSchedule'
            } else if (this.isAfterScheduleType) {
                module = 'schedule'
                method = 'importAfterSchedule'
            } else if (this.isSysUserType) {
                module ='user'
                method = 'importUser'
            } else if (this.isExceptions) {
                module ='exceptions'
                method = 'importExceptions'
            }
            console.log(this.importPar)
            debugger
            console.log(module)
            console.log(method)
            if (this.isZhaoLuRankImport) {
                this.importPar.type = this.importExcelType
            } else {
                delete this.importPar.type
            }
            if (method === 'importExamAreaAgent') {
                this.$api.exam.importExamAreaAgent(this.importPar).then(res => {
                    if (!res.success) {
                        this.$message({ message: res.message, type: 'error' })
                        return
                    }
                    this.$message({ message: '操作成功', type: 'success' })
                })
            } else if (method === 'importZLRank') {
                this.$api.ZlInfo.importZLRank(this.importPar).then(res => {
                    if (!res.success) {
                        this.$message({ message: res.message, type: 'error' })
                        return
                    }
                    this.$message({ message: '操作成功', type: 'success' })
                })
            } else {
                console.log(this.$api[module][method])
                this.$api[module][method](this.importPar).then(res => {
                    if (!res.success) {
                        this.$message({ message: res.message, type: 'error' })
                        return
                    }
                    this.$message({ message: '操作成功', type: 'success' })
                })
            }
        },
        handleShoMore(par) {
            // if (par.row.status == '处理成功') {
            //     this.$alert(par.row.status, '详情', {
            //         confirmButtonText: '确定'
            //     })
            // } else
            if (par.row.status === '处理中') {
                this.$alert(par.row.status, '详情', {
                    confirmButtonText: '确定'
                })
            } else {
                const data = { id: par.row.id }
                this.$api.keyWord.getLog(data).then(res => {
                    if (!res.success) {
                        this.$message({ message: res.data, type: 'error' })
                        return
                    }

                    this.$alert(res.data, '详情', {
                        confirmButtonText: '确定'
                    })
                })
            }
        },
        forMat(q, w, row) {
            debugger
            w.renderCell = function(h, params) {
                if (params.row.status === '处理成功') {
                    return h(
                        'a',
                        {
                            attrs: {
                                href: params.row.url
                            },
                            style: {
                                color: '#14aaff'
                            }
                        },
                        `${params.row.url}`
                    )
                } else {
                    return h('span', {}, params.row.url)
                }
            }
        },
        getProgress(q, w, row) {
            w.renderCell = function(h, params) {
                if (params.row.status === '处理成功') {
                    return h('span', {}, '100%')
                } else if (params.row.status === '处理中') {
                    // 超过三十分钟的任务，不再请求进度
                    var time = new Date().getTime()
                    if (
                        time - Date.parse(params.row.createTime) >
                        30 * 60 * 1000
                    ) {
                        return
                    }
                    this.$api.base
                        .getProgress({ id: params.row.id })
                        .then(res => {
                            if (res && !res.success) {
                                this.$message({
                                    message: res.message,
                                    type: 'error'
                                })
                                return
                            }
                            this.progressData = res.data + '%'
                        })
                    return h('span', {}, this.progressData)
                }
            }
        },
        initColumns: function() {
            this.columns = [
                { prop: 'id', label: 'id', minWidth: 40 },
                { prop: 'bizType', label: '操作类型', minWidth: 80 },
                { prop: 'status', label: '状态', minWidth: 50 },
                {
                    prop: 'logUrl',
                    label: '文件路径',
                    minWidth: 190,
                    formatter: this.forMat
                },
                { prop: 'createTime', label: '时间', minWidth: 100 },
                { prop: 'batch', label: '批次', minWidth: 100 },
                {
                    prop: 'progress',
                    label: '进度',
                    minWidth: 50,
                    formatter: this.getProgress
                }
            ]
        },
        hideDialog() {
            this.$emit('closeImport', this.importForm)
        },
        selectionChange() {},
        handleCurrentHandle() {},
        getRecodes(dt) {
            var param = {
                bizTypeVal: this.importType
            }
            if (dt) {
                Object.assign(param, dt.pageRequest)
                this.pageRe = dt
            }
            param.size = 5
            this.$api.base.getLogList(param).then(res => {
                if (res && !res.success) {
                    this.$message({ message: res.message, type: 'error' })
                    this.loading = false
                    return
                }

                this.page = res.data
                if (!dt) {
                    this.hisL = res.data
                }
                this.loading = false
                if (!this.interVal) {
                    this.interVal = setInterval(() => {
                        // debugger
                        this.getRecodes(this.pageRe)
                    }, 2000)
                }
            })
        },
        dlFile(data) {
            if (data.row.status !== '处理成功') {
                this.$message({
                    message: data.row.logUrl || data.row.status,
                    type: 'warning'
                })
                return
            }
            const url = data.row.url
            window.open(url.replace('http:', 'https:'))
        },
        downloadTemplate() {
            // this.$emit('handleSetExport')
            let url = ''
            url =
                'https://testbase.lpswish.com/api/base/download/excel/template' +
                '?' +
                `tableId=${this.importableId}` +
                `&title=${this.importitle}` +
                '模板'
            const xhr = new XMLHttpRequest()
            var that = this
            xhr.onreadystatechange = function() {
                if (xhr.readyState === 4) {
                    if (xhr.status === 200) {
                        console.log(xhr)
                        window.open(url)
                    } else {
                        const res = JSON.parse(xhr.response)
                        that.$message({
                            message: res.data.error,
                            type: 'error'
                        })
                        return
                    }
                } else {
                    /* 暂不处理*/
                }
            }
            xhr.open('get', url)
            xhr.send()
        }
    },
    beforeDestroy() {
        if (this.interVal) {
            clearInterval(this.interVal)
            this.interVal = ''
        }
    },
    destroyed() {
        clearInterval(this.interVal)
        this.interVal = ''
    },
    mounted() {
        this.initColumns()
        this.getRecodes()
        console.log('importType', this.importType)
    }
}
</script>
<style scoped>
.el-button--medium {
    padding: 7px 13px;
    width: 76.3px;
    font-size: 12px;
    border-radius: 4px;
}
.el-upload-tip {
    white-space: nowrap;
}
.importBtn {
    position: absolute;
    right: 67px;
}
.download-btn {
    color: #fff;
    text-decoration: none;
    padding: 7px 13px;
    font-size: 12px;
    border-radius: 4px;
}
.dialog-btn {
    margin-top: 40px;
}
</style>



// WEBPACK FOOTER //
// src/components/Component/ImportData/Index.vue